import { Component, HostBinding, Input } from '@angular/core';
import { ProductSearchPage, ProductSearchService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CustomCmsItemComponentData } from './custom-cms-item.model';

@Component({
  selector: 'app-custom-cms-item',
  templateUrl: './custom-cms-item.component.html',
  styleUrls: ['./custom-cms-item.component.scss'],
  standalone: false
})
export class CustomCmsItemComponent {
  @Input() item: CustomCmsItemComponentData;
  @Input() isGrid: Boolean;
  @HostBinding('class') styleClasses: string;

  constructor(
    public component: CmsComponentData<CustomCmsItemComponentData>,
    protected productSearchService: ProductSearchService,
  ) { }

  searchResults$: Observable<ProductSearchPage> = this.productSearchService
    .getResults()
    .pipe(filter((searchResult) => Object.keys(searchResult).length > 0));
}
